// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DisclaimerHero-module--wrapper--87bnV","content":"DisclaimerHero-module--content--2ibje"};